<template>
    <div class="tooltip-wrap">
        <button v-on:click="status = !status" v-bind:class="status === true ? 'click' : ''" class="btn-tooltip"><i class="bi bi-exclamation-circle"></i></button>
        <div v-if="status" class="tooltip-container">
            {{description}}
        </div>
    </div>
</template>

<script>
export default {
    name: "Tooltip",
    props: ['description'],
    data(){
        return {
            status: false
        }
    }
}
</script>

<style scoped>
.btn-tooltip {
    font-size: 14px;
    border-color: transparent;
    background: transparent;
    padding: 0;
}
.btn-tooltip:hover{
    color: #ec550e;
}
.click {
    color: #ec550e;
}
.tooltip-container {
    background: #fff;
    position: absolute;
    z-index: 999;
    box-shadow: 0 2px 4px 0 hsl(0deg 0% 84% / 50%);
    padding: 5px;
    min-width: 175px;
    max-width: 200px;
    font-size: 13px;
}
.tooltip-wrap {
    position: relative;
}
</style>
